import { useState, useEffect } from 'react';
import { useRouter } from 'next/router';
import useIsMobile from 'hooks/utils/useIsMobile';
import NavigationSideBar from 'components/account/navigationSideBar';
import Dashboard from 'components/account/dashboard';
import styles from './customerAccount.module.scss';

const CustomerAccount = ({
  locale,
  customer,
  accountpagenavigation,
  dashboardaccountpage,
  ordersaccountpage,
  orderdetailsaccountpage,
  secondorderdetailsaccountpage,
  personalinfoaccountpage,
  secondpersonalinfoaccountpage,
  thirdpersonalinfoaccountpage,
  addressbookaccountpage,
  addaddressformaccountpage,
  secondaddressbookaccountpage,
  checkout,
  salonselector,
  registermessages,
  subscriptionsLink,
}) => {
  const router = useRouter();
  const isMobile = useIsMobile();
  const [navTracker, setNavTracker] = useState('dashboard');
  const [showDetails, setShowDetails] = useState(false);
  const [order, setOrder] = useState({});
  const [toggleAddForm, setAddToggleForm] = useState(false);
  const [toggleUpdateForm, setUpdateToggleForm] = useState(false);

  useEffect(() => {
    setNavTracker(router.query?.section[0] || 'dashboard');
  }, [router]);

  return (
    <div className={styles.container}>
      {!isMobile && (
        <NavigationSideBar
          locale={locale}
          customer={customer}
          navTracker={navTracker}
          setNavTracker={setNavTracker}
          setShowDetails={setShowDetails}
          setAddToggleForm={setAddToggleForm}
          setUpdateToggleForm={setUpdateToggleForm}
          accountpagenavigation={accountpagenavigation}
        />
      )}
      <Dashboard
        locale={locale}
        customer={customer}
        navTracker={navTracker}
        showDetails={showDetails}
        order={order}
        toggleAddForm={toggleAddForm}
        toggleUpdateForm={toggleUpdateForm}
        setNavTracker={setNavTracker}
        setShowDetails={setShowDetails}
        setOrder={setOrder}
        setAddToggleForm={setAddToggleForm}
        setUpdateToggleForm={setUpdateToggleForm}
        accountpagenavigation={accountpagenavigation}
        dashboardaccountpage={dashboardaccountpage}
        ordersaccountpage={ordersaccountpage}
        orderdetailsaccountpage={orderdetailsaccountpage}
        secondorderdetailsaccountpage={secondorderdetailsaccountpage}
        personalinfoaccountpage={personalinfoaccountpage}
        secondpersonalinfoaccountpage={secondpersonalinfoaccountpage}
        thirdpersonalinfoaccountpage={thirdpersonalinfoaccountpage}
        addressbookaccountpage={addressbookaccountpage}
        addaddressformaccountpage={addaddressformaccountpage}
        secondaddressbookaccountpage={secondaddressbookaccountpage}
        checkout={checkout}
        salonselector={salonselector}
        registermessages={registermessages}
        subscriptionsLink={subscriptionsLink}
      />
    </div>
  );
};

export default CustomerAccount;
